import { render, staticRenderFns } from "./NewUgcModal.vue?vue&type=template&id=10e37242"
import script from "./NewUgcModal.vue?vue&type=script&lang=js"
export * from "./NewUgcModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports